export default [
    {
        path: '/course-clusters',
        name: 'course-clusters',
        component: () => import ('./views/CourseClusterIndex'),
        meta: {
            title: 'Clusters de Curso',
            icon: 'mdi-approximately-equal-box',
        }
    },
]
